export enum PlatformApplyWithProfileMode {
  APPLY = 'apply',
  FOLLOW_UP = 'follow-up',
}
